import { isNil } from 'lodash-es'

type Refs<T = unknown> = Maybe<React.RefObject<T | null> | React.LegacyRef<T> | React.RefObject<T | null>>
/**
 * Merges array of refs (e.g. local and external forwarded refs)
 * @param {React.Ref[]} refs - Array of refs (objects or functions)
 * @returns {void}
 */
export const mergeRefs =
  <T = unknown>(...refs: (Refs<T> | Refs<T>[])[]): React.RefCallback<T> =>
  (value) => {
    refs.flat().forEach((ref) => {
      if (typeof ref === 'function') {
        ref(value)
      } else if (!isNil(ref)) {
        ;(ref as React.RefObject<T | null>).current = value
      }
    })
  }
